/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForAwsSaasUserManagedOnboarded extends models.StorageConfigurationBaseForAwsSaas {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForAwsSaasUserManagedOnboarded");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForAwsSaasUserManagedOnboarded.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForAwsSaasUserManagedOnboarded>): StorageConfigurationForAwsSaasUserManagedOnboarded {
        let obj = Object.assign(new StorageConfigurationForAwsSaasUserManagedOnboarded(), model);
        StorageConfigurationForAwsSaasUserManagedOnboarded.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForAwsSaasUserManagedOnboarded>): StorageConfigurationForAwsSaasUserManagedOnboarded {
        if (!model) return null;
        return StorageConfigurationForAwsSaasUserManagedOnboarded.newInstance(<StorageConfigurationForAwsSaasUserManagedOnboarded> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForAwsSaasUserManagedOnboarded) {
        if (!obj) return;

        models.StorageConfigurationForAwsSaasUserManagedOnboarded.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForAwsSaasUserManagedOnboarded): boolean {
        if (models.StorageConfigurationBaseForAwsSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForAwsSaasUserManagedOnboarded.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Reference to the Service Account under which the storage is present.
     */
    account_id: string;

}
